import * as Schema from "effect/Schema";
import { IsoDateTime, NonNegativeInt, PositiveInt } from "./baseSchemas.js";
/** Only disk quotas use the warning level. */
export const QuotaLevel = Schema.Literals(["ok", "warning", "exhausted"]);
export const QuotaStatus = Schema.Struct({
    level: QuotaLevel,
    /** The UTC renewal of an exhausted money quota; absent for disk and ok quotas. */
    renewsAt: Schema.optionalKey(IsoDateTime),
});
export const QuotaBudget = Schema.Struct({
    kind: Schema.Literals(["monthly", "five_hour", "weekly"]),
    /** Settled plus unknown spend divided by the limit; zero limits report 1 and are exhausted. */
    usedRatio: Schema.Number,
    /** Null until an enabled rolling window opens. */
    resetsAt: Schema.NullOr(IsoDateTime),
    exhausted: Schema.Boolean,
});
export const MoneyQuotaStatus = Schema.Struct({
    ...QuotaStatus.fields,
    /** Empty outside a subscription in force, where the quota level is ok. */
    budgets: Schema.Array(QuotaBudget),
});
export const OrganizationQuotas = Schema.Struct({
    /** Any exhausted agent budget exhausts this quota; renewal is the latest exhausted budget end. */
    agent: MoneyQuotaStatus,
    ocr: MoneyQuotaStatus,
    /** Null until a web workspace has a measurement. */
    storage: Schema.NullOr(Schema.Struct({
        ...QuotaStatus.fields,
        usedBytes: NonNegativeInt,
        limitBytes: PositiveInt,
        measuredAt: IsoDateTime,
    })),
});
